import { AxiosError } from 'axios'
import startOfMonth from 'date-fns/startOfMonth'

import logger from '@/sdk/logger'
import { userRequest } from '@/sdk/oauth'
import { Booking } from '@/store/bookings/types'

export function fetchBookings({
  from,
  to,
}: {
  from?: Date
  to?: Date
}): Promise<Booking[]> {
  return userRequest
    .get(`customer/booking`, {
      params: {
        'from-booking-date': from,
        'to-booking-date': to,
      },
    })
    .then(response => response.data)
    .catch((error: AxiosError) => {
      logger.error('failed fetching bookings list', {
        error,
        tags: ['bookings', 'http'],
      })

      throw error
    })
}

export function fetchPastBookings(): Promise<Booking[]> {
  return fetchBookings({ to: new Date() })
}

export function fetchBookingsFromBeginningOfMonth(): Promise<Booking[]> {
  return fetchBookings({ from: startOfMonth(new Date()) })
}
